module.exports = __webpack_public_path__ + "static/img/bpr.ebd238c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/work/bpr.png
// module id = AKhq
// module chunks = 0